export default "__VITE_ASSET__Cp8JN5UN__"